import { type MCPServerInfo } from '../../types';

const FirefliesServer: MCPServerInfo = {
  serverId: 'FIREFLIES',
  name: 'Fireflies.ai',
  slug: 'fireflies',
  description: 'Fireflies.ai MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.fireflies.ai/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default FirefliesServer;
